import React, { useState, useMemo } from "react";
import "./styles.css";
import { TextField, Grid, Typography, InputAdornment, Icon } from "@mui/material";
import "react-spring-bottom-sheet/dist/style.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Button from "../../components/Button";
import DialogComponent from "../../components/Dialog-Popup";
import defaultProfile from "../../assets/profilePic.jpg";

export default function EditProfile() {
    const [profilePic, setProfilePic] = useState(defaultProfile);
    const [openPopup, setOpenPopup] = useState(false);
    const [popuptitle, SetPopupTitle] = useState("");
    const [popupContent, SetPopupContent] = useState("");
    const [buttonArr, setButtonArr] = useState([]);
    const [values, setValues] = React.useState({
        fName: 'Divya',
        lName: 'Malik',
        email: 'divya.malik@ibm.com',
        mobileNo: '8888888888',
        nationalId: '91'
    });
 
    const handleChange = name => event => {
        setValues({ ...values, [name]: event.target.value });
    };

    const isEmailValid = useMemo(() => {
        var validEmailReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if(values.email.match(validEmailReg)){
            return true
           }
           else{return false}

    }, [values])

    const isMobileNoValid = useMemo(() => {
        var validPhoneReg = /^\d{10}$/;
       if(values.mobileNo.match(validPhoneReg)){
        return true
       }
       else{return false}

    }, [values])

    const disableEditButton = useMemo(() => {
        if(values.fName ==='' || values.lName==='' || values.email===''|| values.mobileNo==='' || values.nationalId==='' || !isEmailValid || !isMobileNoValid){
           return true
        }
        else return false
       

    }, [values, isEmailValid, isMobileNoValid])

    const handleProfilePicChange = (e) => {
        const files = e.target.files;
        setProfilePic(URL.createObjectURL(files[0]))
    };

    function deleteProfilePic() {
        setOpenPopup(false);
    }
    const handleProfileDeletetion = () => {
        setOpenPopup(true);
        setProfilePic(defaultProfile)
        SetPopupTitle("Photo Removed");
        SetPopupContent(
            "Successfully removed the profile photo"
        );
        let btnValues = [
            {
                id: "1",
                value: "Ok",
                fontWeight: "bold",
                color: "borderLess",
                showCondition: "true",
                functionCall: deleteProfilePic,
            }
        ];
        setButtonArr(btnValues);
    }

    return (
        <Grid container height='100%' className='edit_container'>
            <Grid style={{ display: "flex", alignItems: "center", padding: '16px', position: "sticky", top: "0", backgroundColor: '#F2F2F2', width: '100%', zIndex: '1' }}>
                <ArrowBackIcon
                    style={{ fontSize: "31", color: "#0d4f57", paddingLeft: "4%" }} />
                <Typography
                    pl={2}
                    style={{
                        fontSize: "17px", fontWeight: '600', letterSpacing: '1', color: '#535353', paddingLeft: '15px'
                    }}
                >
                    Edit Profile
                </Typography>

            </Grid>

            <Grid padding="6%" height="90%" bgcolor="white" className='formGrid'>
                <Grid className="card-img-section">
                    <Grid className='img-container'>
                        <img src={profilePic} style={{ height: '100px', width: '100px' }} alt="" />
                        <div display='flex' flexDirection='row' justifyContent='space-between'>
                            <label htmlFor="uploadDoc_icon">
                                <Icon className="picture"><CameraAltIcon /></Icon>
                            </label>
                            <input
                                id="uploadDoc_icon"
                                accept="image/*"
                                type="file"
                                name="file"
                                onChange={(e) => handleProfilePicChange(e)}
                            />

                            <Icon onClick={handleProfileDeletetion} className="delete"><DeleteOutlineIcon /></Icon>
                        </div>
                    </Grid>
                    <Grid className='typography' >
                        <Typography
                            style={{
                                fontSize: "15px",
                                top: '80px'
                            }}
                            color="#000000"
                        >
                            Hi, Nombuso
                        </Typography>
                    </Grid>
                </Grid>
                <DialogComponent
                    openPopup={openPopup}
                    popuptitle={popuptitle}
                    popupContent={popupContent}
                    buttonValue={buttonArr}
                />

                <Grid item sm={6} lg={12} pb={1} className="grid">
                    <label htmlFor="name" className="labelTextField">
                        What is your first name ?
                    </label>
                    <TextField size="small" value={values.fName} error={values.fName === ""} helperText={values.fName === "" ? 'Please enter first Name' : ' '} onChange={handleChange("fName")} placeholder="Add first Name" fullWidth className="textBox" />
                </Grid>
                <Grid item sm={6} pb={1} lg={12} className="grid">
                    <label htmlFor="name" className="labelTextField">
                        What is your last name ?
                    </label>
                    <TextField size="small" value={values.lName} error={values.lName === ""} helperText={values.lName === "" ? 'Please enter last Name' : ' '} onChange={handleChange("lName")} placeholder="Add Last Name" fullWidth className="textBox" />
                </Grid>
                <Grid item sm={6} pb={1} lg={12} className="grid">
                    <label htmlFor="name" className="labelTextField">
                        Email ID
                    </label>
                    <TextField size="small" value={values.email} error={!isEmailValid } helperText={!isEmailValid ? 'Please enter valid email Id ' : ' '} onChange={handleChange("email")} placeholder="Add Last Name" fullWidth className="textBox" />
                </Grid>
                <Grid item sm={6} pb={1} lg={12} className="grid">
                    <label htmlFor="name" className="labelTextField">
                        Mobile Number
                    </label>
                    <TextField size="small" value={values.mobileNo} error={!isMobileNoValid} helperText={!isMobileNoValid ? 'Please enter valid Mobile No.' : ' '} onChange={handleChange("mobileNo")} placeholder="Enter Mobile Number" fullWidth className="textBox"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start"> +27 |</InputAdornment>
                            ),
                        }} />
                </Grid>
                <Grid item sm={6} pb={1} lg={12} className="grid">
                    <label htmlFor="name" className="labelTextField">
                        What is your National ID
                    </label>
                    <TextField size="small" value={values.nationalId} error={values.nationalId === ""} helperText={values.nationalId === "" ? 'NationalId cannot be empty' : ' '} onChange={handleChange("nationalId")} placeholder="Add your national ID" fullWidth className="textBox" />
                </Grid>
            </Grid>
            <Grid display="flex" flexDirection="row" alignItems="center" justifyContent="center" bgcolor="#ffffff" padding="12px 20px 12px 20px" width="100%" sx={{ position: 'fixed', bottom: 0, boxShadow: 8 }}>
                <Button
                    color={disableEditButton ? "grey" :" green"}
                    name="Update Details"
                    disabled={disableEditButton}
                />
            </Grid>
        </Grid>
    );
}

